import { BreakingErrors } from '../core/enums/breakingErrors';
import { FeatureFlags } from '../core/enums/featureFlags';
import { Steps, EventTypes, FormFields, IAnalytics } from '../core/services/analytics/module';
import { toggleTechnicalDifficultiesModal, executeWhenTechnicalDifficultiesModalEnabled } from './technicalDifficultiesModalEnabled';
import { IFeatureFlagRepository } from '@delta-defense/feature-flag-service/service/iFeatureFlagRepository';

export const displayTechnicalDifficultiesModal = (
	features: IFeatureFlagRepository,
	analytics: IAnalytics
) => {
	try {
		import('@delta-defense/technical-difficulties-modal/components/technicalDifficultiesModal/module');
	} catch {
		// do nothing
	}
	if (features.IsEnabled(FeatureFlags.TechnicalDifficulties)) {
		toggleTechnicalDifficultiesModal(true);
	}

	executeWhenTechnicalDifficultiesModalEnabled(() => {
		analytics.TrackError({
			event_name: BreakingErrors.TechnicalDifficulties,
			step: Steps.One,
			events: {
				error_text: 'Technical Difficulties',
				error_type: EventTypes.Checkout,
				form_field: FormFields.BeginCheckout
			}
		});
	});
};

